import util from '@/libs/util.js'
import { AccountLogin } from '@/api/login'
import { frameInRoutes } from '@/router/routes'
import { GetMenu } from '@api/common'

export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param username {String} 用户账号
     * @param {Object} param password {String} 密码
     * @param {Object} param route {Object} 登录成功后定向的路由对象
     */
    login ({ dispatch }, {
      vm,
      username,
      password,
      uuid,
      captcha,
      loginType,
      email,
      route = {
        name: 'index'
      }
    }) {
      vm.$message({
        message: '登录请求中请稍后...',
        type: 'info',
        duration: 0
      })
      // 开始请求登录接口
      AccountLogin({
        username,
        password,
        uuid,
        captcha,
        loginType,
        email
      })
        .then(async res => {
          if (res.oktaLoginFlag && res.oktaLoginFlag === 'YES') {
            // 这个用户必须走okta登录
            vm.$router.push({ name: 'oktaLoginIndex' })
            return
          }
          if (!res.popup) {
            // 设置 cookie 一定要存 uuid 和 token 两个 cookie
            // 整个系统依赖这两个数据进行校验和存储
            // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
            // token 代表用户当前登录状态 建议在网络请求中携带 token
            // 如有必要 token 需要定时更新，默认保存一天
            util.cookies.set('uuid', res.uuid)
            util.cookies.set('token', res.token, { expires: res.expire })
            util.cookies.set('userId', res.userId)
            util.cookies.set('userType', res.userType)
            util.cookies.set('profilePictureUrl', res.profilePictureUrl)
            // 设置 vuex 用户信息
            await dispatch('d2admin/user/set', {
              name: res.name,
              profilePictureUrl: res.profilePictureUrl,
              passwordFlag: res.passwordFlag,
              messageFlag: res.messageFlag
            }, { root: true })
            // 用户登录后从持久化数据加载一系列的设置
            await dispatch('load')
            // 更新路由 尝试去获取 cookie 里保存的需要重定向的页面完整地址
            const path = util.cookies.get('redirect')
            // 根据是否存有重定向页面判断如何重定向
            vm.$router.replace(path ? { path } : route)
            // 删除 cookie 中保存的重定向页面
            util.cookies.remove('redirect')
            GetMenu().then(res => {
              // 处理路由 得到每一级的路由设置
              vm.$store.commit('d2admin/page/init', frameInRoutes)
              // 设置顶栏菜单
              vm.$store.commit('d2admin/menu/headerSet', res.menuList)
              // 初始化菜单搜索功能
              vm.$store.commit('d2admin/search/init', res.menuList)
              // 设置侧边栏菜单
              vm.$store.commit('d2admin/menu/asideSet', res.menuList)
            })
            if (vm.rememberPwd) {
              util.cookies.set('username', vm.formLogin.username)
              util.cookies.set('password', vm.formLogin.password)
              util.cookies.set('rememberPwd', vm.rememberPwd)
            }
            vm.$message.closeAll()
            vm.$message.success('登录成功。')
            vm.$router.push({
              name: 'index'
            })
          } else {
            vm.$confirm('<ol><li>更新了北京公司注册地址</li>' +
              '<li>第12条增加了授权瑞思迈在获得患者授权的情况下，访问该经销商管理的该患者数据的权利，以提供相关服务。</li></ol>' +
              '<br/><p>详情请查看《<a target="_blank" href="https://www.airviewresmed.cn/static/file/ResMed%20Airview%20Terms%20of%20Use.pdf">瑞思迈AirView使用条款</a>》。如您有任何疑问请联系瑞思迈，如您未联系，则视为同意并认可该协议。</p>', 'Airview使用条款更新', {
              dangerouslyUseHTMLString: true,
              distinguishCancelAndClose: true,
              showClose: false,
              showCancelButton: false,
              closeOnClickModal: false
            })
              .then(async () => {
                // 设置 cookie 一定要存 uuid 和 token 两个 cookie
                // 整个系统依赖这两个数据进行校验和存储
                // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
                // token 代表用户当前登录状态 建议在网络请求中携带 token
                // 如有必要 token 需要定时更新，默认保存一天
                util.cookies.set('uuid', res.uuid)
                util.cookies.set('token', res.token, { expires: res.expire })
                util.cookies.set('userId', res.userId)
                util.cookies.set('userType', res.userType)
                util.cookies.set('profilePictureUrl', res.profilePictureUrl)
                // 设置 vuex 用户信息
                await dispatch('d2admin/user/set', {
                  name: res.name,
                  profilePictureUrl: res.profilePictureUrl,
                  passwordFlag: res.passwordFlag,
                  messageFlag: res.messageFlag
                }, { root: true })
                // 用户登录后从持久化数据加载一系列的设置
                await dispatch('load')
                // 更新路由 尝试去获取 cookie 里保存的需要重定向的页面完整地址
                const path = util.cookies.get('redirect')
                // 根据是否存有重定向页面判断如何重定向
                vm.$router.replace(path ? { path } : route)
                // 删除 cookie 中保存的重定向页面
                util.cookies.remove('redirect')
                GetMenu().then(res => {
                  // 处理路由 得到每一级的路由设置
                  vm.$store.commit('d2admin/page/init', frameInRoutes)
                  // 设置顶栏菜单
                  vm.$store.commit('d2admin/menu/headerSet', res.menuList)
                  // 初始化菜单搜索功能
                  vm.$store.commit('d2admin/search/init', res.menuList)
                  // 设置侧边栏菜单
                  vm.$store.commit('d2admin/menu/asideSet', res.menuList)
                })
                if (vm.rememberPwd) {
                  util.cookies.set('username', vm.formLogin.username)
                  util.cookies.set('password', vm.formLogin.password)
                  util.cookies.set('rememberPwd', vm.rememberPwd)
                }
                vm.$message.closeAll()
                vm.$message.success('登录成功。')
                vm.$router.push({
                  name: 'index'
                })
              })
              .catch(action => {
                // console.log(222)
              })
          }
        })
        .catch(err => {
          vm.$message.closeAll()
          vm.getCaptcha()
          vm.$message.error(err.message)
          console.log('err: ', err)
        })
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param confirm {Boolean} 是否需要确认
     */
    logout ({ commit }, { vm, confirm = false }) {
      /**
       * @description 注销
       */
      function logout () {
        // 删除cookie
        util.cookies.remove('token')
        util.cookies.remove('uuid')

        if (vm.authState.isAuthenticated) {
          // 已经okta登录，也需要退出
          vm.$router.push({ name: 'oktaLoginLogout' })
        } else {
          // 跳转路由
          vm.$router.push({
            name: 'login'
          })
        }
      }
      // 判断是否需要确认
      if (confirm) {
        commit('d2admin/gray/set', true, { root: true })
        vm.$confirm('注销当前账户吗？打开的标签页和用户设置将不会被保存。', '确认操作', {
          confirmButtonText: '确定注销',
          cancelButtonText: '放弃',
          type: 'warning'
        })
          .then(() => {
            commit('d2admin/gray/set', false, { root: true })
            logout()
          })
          .catch(() => {
            commit('d2admin/gray/set', false, { root: true })
            vm.$message('放弃注销用户')
          })
      } else {
        logout()
      }
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} state vuex state
     */
    load ({ commit, dispatch }) {
      return new Promise(async resolve => {
        // DB -> store 加载用户名
        await dispatch('d2admin/user/load', null, { root: true })
        // DB -> store 加载主题
        await dispatch('d2admin/theme/load', null, { root: true })
        // DB -> store 加载页面过渡效果设置
        await dispatch('d2admin/transition/load', null, { root: true })
        // DB -> store 持久化数据加载上次退出时的多页列表
        await dispatch('d2admin/page/openedLoad', null, { root: true })
        // DB -> store 持久化数据加载侧边栏折叠状态
        await dispatch('d2admin/menu/asideCollapseLoad', null, { root: true })
        // DB -> store 持久化数据加载全局尺寸
        await dispatch('d2admin/size/load', null, { root: true })
        // end
        resolve()
      })
    }
  }
}
